
<div class="card-profile-sales-graph-header">
  <align>
    <div>
      <helper-text :help-text="helpText">
        <h4 class="short-text secondary-font">{{ titleText }}</h4>
      </helper-text>

      <div class="small-text" v-if="auctionOnly && cardId">Auctions only</div>
    </div>
  </align>

  <align small-gap>
    <pro-label
      v-if="isPublic"
      tooltip="Go Pro today to see all individual sales!"
      as="nuxt-link"
      to="/pricing"
    />

    <icon-link v-if="showViewAllSales" @click="goToSales">
      View All Sales
    </icon-link>
  </align>
</div>
